module.exports = __webpack_public_path__ + "img/icon-home-fixed-account.9b299435.svg";